<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDER_DETAILS.GENERAL_TAB_LABEL' | translate }}</h3>
    </div>
    <div class="sp-row__align">
      <div
        [ngClass]="getOrderStatusClass(order?.status)"
        class="sp-order__status-radius sp-row__center sp-padding__horiz">
        <span class="sp-text__ellipsized sp-text__center">{{
          (getOrderStatusLabel(order?.status) | translate | lowercase) || '-'
        }}</span>
      </div>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDERS.ORDER_ID_COLUMN_LABEL'"
      [content]="order?.order_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.CREATED_AT_COLUMN_LABEL'"
      [content]="(order?.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info [label]="'ORDERS.ORIGIN_COLUMN_LABEL'">
      <app-shared-order-origin [order]="order"></app-shared-order-origin>
    </app-shared-info>
    <app-shared-info-copy
      [label]="'ORDERS.EXT_ORDER_ID_LABEL'"
      [content]="order?.ext_order_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.COMPLETED_AT_COLUMN_LABEL'"
      [content]="(order?.running_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.END_DATE_COLUMN_LABEL'"
      [content]="(order?.end_date | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.APPROVED_DATE_LABEL'"
      [content]="(order?.ready_for_liquidation_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.AMOUNT_COLUMN_LABEL'"
      [content]="getFormattedAmount(order)"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
    <app-shared-info
      [label]="'ORDERS.INSTALMENTS_COLUMN_LABEL'"
      [content]="(order?.summary?.total || '-') + ''"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
    <app-shared-info
      [label]="'ORDERS.BD1_RESULT'"
      [content]="decido_evaluation_bd1?.result?.result || '-' | uppercase"
      [content_class]="getEvaluationClass(decido_evaluation_bd1?.result?.result)"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.BD2_RESULT'"
      [content]="decido_evaluation_bd2?.result?.result || '-' | uppercase"
      [content_class]="getEvaluationClass(decido_evaluation_bd2?.result?.result)"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.BD5_RESULT'"
      [content]="decido_evaluation_bd5?.result?.result || '-' | uppercase"
      [content_class]="getEvaluationClass(decido_evaluation_bd5?.result?.result)"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.LIQUIDATION_COLUMN_LABEL'"
      [content]="(order?.liquidated_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.IS_LOOKED_AT_LABEL'"
      [content]="order?.is_looked_at ? 'GENERAL.YES_LABEL' : 'GENERAL.NO_LABEL'"
      [is_update_enabled]="true"
      (update_click)="onEditLookedAtClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      class="sp-order-details-general-info__note"
      [label]="'GENERAL.NOTE_LABEL'"
      [content]="order?.note || '-'"
      [is_update_enabled]="true"
      (update_click)="onEditNoteClick()"
      [content_class]="'sp-text__ellipsized'"
      [matTooltip]="order?.note || '-'"></app-shared-info>
  </div>
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-padding">{{ 'COMPANIES.CONTRACTS_DETAILS_TITLE' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'BUYERS.FEA_CONTRACT_ID_LABEL'"
      [content]="order?.fea_contract_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.CONTRACT_ID_LABEL'"
      [content]="order?.contract_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
  </div>
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-padding">{{ 'STORES.PLUGINS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info
      [label]="'COMPANIES.CMS_LABEL'"
      [content]="order?.references?.cms || '-'"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
    <app-shared-info
      [label]="'ORDERS.PLUGIN_VERSION_LABEL'"
      [content]="order?.references?.plugin_version || '-'"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
    <app-shared-info-copy
      [label]="'ORDERS.SUCCESS_REF_LABEL'"
      [content]="order?.references?.success_ref || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.FAILURE_REF_LABEL'"
      [content]="order?.references?.failure_ref || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.THANK_YOU_PAGE_LABEL'"
      [content]="order?.references?.thank_you_page || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.FAILURE_PAGE_LABEL'"
      [content]="order?.references?.failure_page || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
  </div>
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-padding">{{ 'ORDERS.REFUND_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-info__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info
      [label]="'ORDERS.REFUND_DATE_LABEL'"
      [content]="(order?.refunded_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
    <app-shared-info
      [label]="'ORDERS.MERCHANT_REFUND_LABEL'"
      [content]="getVbanStatusLabel(order?.vban_status) || '-'"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
  </div>
</div>
